import { render, staticRenderFns } from "./CategoryAdd.vue?vue&type=template&id=36e56ace&scoped=true"
import script from "./CategoryAdd.vue?vue&type=script&lang=js"
export * from "./CategoryAdd.vue?vue&type=script&lang=js"
import style0 from "./CategoryAdd.vue?vue&type=style&index=0&id=36e56ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e56ace",
  null
  
)

export default component.exports